import * as React from 'react';

import GroupAvatar, { Props as GroupAvatarProps } from 'groups/components/GroupAvatar';
import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';

type Props = Omit<GroupAvatarProps, 'group'> & { entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity };

export default function GroupRecipientAvatar(props: Props) {
  const { entity, ...otherProps } = props;
  const { avatar } = entity.content;
  
  const group = avatar.__typename === 'UserInitialsAvatar' ? { initials: avatar.initials } : { groupAvatar: { svg_url: avatar.imageUrl } };

  return (
    <GroupAvatar {...otherProps} group={group} />
  )
}
